
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/verify",
      function () {
        return require("private-next-pages/events/verify/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/verify"])
      });
    }
  